<div class="form-title-container">
  <h3>Órgano de Administración</h3>
</div>

<div class="columns is-multiline" [formGroup]="store.administrationForm">
  <div class="column is-12 form-container">
    <span class="label">Sistema de Administración</span>
    <p-dropdown
      [options]="store.adminSystemOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Seleccionar sistema"
      formControlName="administrationSystem"
      class="search-input"
      (onChange)="onAdminSystemChange($event)"
    >
    </p-dropdown>
  </div>
</div>

<div class="form-title-container">
  <span class="label" style="font-weight: 300;">Miembros administración</span>
  <button class="button add-button" (click)="store.openMemberModal()" [disabled]="!store.administrationForm.get('administrationSystem')?.value">Añadir miembro</button>
</div>

<div class="card" style="margin-bottom: 3rem;">
  <app-clients-table
    [configTable]="store.membersTableConfig()"
    (openItemEvent)="store.openMemberModal($event)"
        (executeActionEvent)="goToMemberDetail($event)"
    (deleteItemEvent)="store.deleteMember($event, deferPersistence())"
  >
  </app-clients-table>
</div>

<div class="modal" [ngClass]="{ 'is-active': store.isMemberModalActive() }">
  <div class="modal-background" (click)="store.closeMemberModal()"></div>
  <div class="modal-card wider-modal">
      <header class="modal-card-head">
          <p class="modal-card-title">
              {{ store.isEditingMember() ? 'Editar miembro' : 'Nuevo miembro' }}
          </p>
          <button class="delete" aria-label="close" (click)="store.closeMemberModal()"></button>
      </header>

      <form [formGroup]="store.memberModalForm" (submit)="saveMember()">
          <section class="modal-card-body">
              <h5 class="section-title">Datos Personales</h5>
              <div class="columns is-multiline">
                  <div class="column is-6 form-container">
                      <span class="label">Cliente</span>
                      <p-dropdown
                          [options]="store.clients()"
                          optionLabel="name"
                          optionValue="id"
                          [filter]="true"
                          filterBy="name"
                          placeholder="Buscar cliente"
                          formControlName="associatedClient"
                          [emptyFilterMessage]="'No se encontraron resultados'"
                          appendTo="body"
                      ></p-dropdown>
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Nombre apellidos / Razón social</span>
                      <input class="search-input" type="text" pInputText formControlName="name" readonly />
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">NIF</span>
                      <input class="search-input" type="text" pInputText formControlName="documentNumber" readonly />
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Domicilio completo</span>
                      <input class="search-input" type="text" pInputText formControlName="address" />
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Nombre Apellidos/Razón Social representante</span>
                      <div class="columns is-mobile" style="margin: 0; gap: 0.5rem; align-items: center;">
                        <div class="column" style="padding: 0;">
                          <p-dropdown
                            [options]="store.representativeOptions()"
                            optionLabel="name"
                            optionValue="id"
                            class="search-input"
                            [filter]="true"
                            filterBy="name"
                            formControlName="representativeId"
                            placeholder="Seleccionar representante"
                            [emptyFilterMessage]="'No se encontraron resultados'"
                            appendTo="body"
                          ></p-dropdown>
                        </div>
                        <div class="column is-narrow" style="padding: 0;">
                          <button type="button" class="button add-button" (click)="store.addRepresentative()">Añadir</button>
                        </div>
                      </div>
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">NIF Representante</span>
                      <input
                        class="search-input"
                        type="text"
                        pInputText
                        formControlName="representativeNif"
                        placeholder="NIF Representante"
                        readonly
                      />
                  </div>

                  @if (store.representatives().length > 0) {
                    <div class="column is-12">
                      <table class="styled-table" style="margin-top: 0.5rem;">
                        <thead>
                          <tr>
                            <th>Representante</th>
                            <th>NIF</th>
                            <th class="icon-cell">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (rep of store.representatives(); let i = $index; track rep.id) {
                            <tr>
                              <td>{{ rep.name }}</td>
                              <td>{{ rep.nif || '-' }}</td>
                              <td class="icon-cell">
                                <a class="close-button" (click)="store.removeRepresentative(i)" title="Eliminar">
                                  <fa-icon [icon]="faTrash"></fa-icon>
                                </a>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  }
              </div>

              @if (store.shouldShowCargoSection()) {
                  <h5 class="section-title">Cargo</h5>
                  <div class="columns is-multiline">
                      @if (store.shouldShowCargoDropdown()) {
                          <div class="column is-6 form-container">
                              <span class="label">Cargo</span>
                              <p-dropdown
                                  [options]="store.cargoOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="Seleccionar cargo"
                                  formControlName="cargo"
                                  appendTo="body"
                              ></p-dropdown>
                          </div>
                      }
                      <div class="column is-3 form-container">
                          <span class="label">Fecha alta cargo</span>
                          <p-calendar formControlName="cargoStartDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
                      </div>
                      <div class="column is-3 form-container">
                          <span class="label">Fecha baja cargo</span>
                          <p-calendar formControlName="cargoEndDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
                      </div>

                      @if (store.shouldShowCargoDropdown()) {
                          <div class="column is-12">
                              <label class="checkbox">
                                  <p-checkbox formControlName="isCeo" [binary]="true"></p-checkbox>
                                  <span class="checkbox-label">Consejero delegado</span>
                              </label>
                          </div>
                          @if (store.memberModalForm.get('isCeo')?.value) {
                              <div class="column is-3 form-container">
                                  <span class="label">Fecha alta</span>
                                  <p-calendar formControlName="ceoStartDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
                              </div>
                              <div class="column is-3 form-container">
                                  <span class="label">Fecha baja</span>
                                  <p-calendar formControlName="ceoEndDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
                              </div>
                          }
                      }
                  </div>
              }

              <h5 class="section-title">Retribución</h5>
              <div class="column is-12">
                   <label class="checkbox">
                      <p-checkbox formControlName="hasRetribution" [binary]="true"></p-checkbox>
                      <span class="checkbox-label">Retribución</span>
                  </label>
              </div>
              @if (store.memberModalForm.get('hasRetribution')?.value) {
                  <div class="columns is-multiline">
                      <div class="column is-12 form-container">
                          <span class="label">Clave de retribución</span>
                          <p-multiSelect
                              [options]="store.retributionKeyOptions"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Seleccionar clave(s)"
                              formControlName="retributionKeys"
                              appendTo="body"
                          ></p-multiSelect>
                      </div>
                       
                       @if (store.memberModalForm.get('retributionKeys')?.value?.includes('A')) {
                          <div class="column is-4 form-container">
                              <span class="label">Importe retribución clave A</span>
                              <p-inputNumber class="search-input" formControlName="retributionAmountA" mode="currency" currency="EUR" locale="es-ES"></p-inputNumber>
                          </div>
                       }
                       @if (store.memberModalForm.get('retributionKeys')?.value?.includes('E')) {
                           <div class="column is-4 form-container">
                              <span class="label">Importe retribución clave E</span>
                              <p-inputNumber class="search-input" formControlName="retributionAmountE" mode="currency" currency="EUR" locale="es-ES"></p-inputNumber>
                           </div>
                       }
                       @if (store.memberModalForm.get('retributionKeys')?.value?.includes('G')) {
                           <div class="column is-4 form-container">
                              <span class="label">Importe retribución clave G</span>
                              <p-inputNumber class="search-input" formControlName="retributionAmountG" mode="currency" currency="EUR" locale="es-ES"></p-inputNumber>
                           </div>
                       }

                       <div class="column is-12 columns is-multiline">
                          <div class="column is-3">
                              <label class="checkbox">
                                  <p-checkbox formControlName="inStatutes" [binary]="true"></p-checkbox>
                                  <span class="checkbox-label">Consta en estatutos</span>
                              </label>
                          </div>
                          <div class="column is-3">
                              <label class="checkbox">
                                  <p-checkbox formControlName="hasContract" [binary]="true"></p-checkbox>
                                  <span class="checkbox-label">Contrato</span>
                              </label>
                          </div>
                           <div class="column is-3">
                              <label class="checkbox">
                                  <p-checkbox formControlName="hasMinutes" [binary]="true"></p-checkbox>
                                  <span class="checkbox-label">Acta</span>
                              </label>
                          </div>
                          <div class="column is-3 form-container">
                              <span class="label">Fecha de inicio</span>
                              <p-calendar formControlName="retributionStartDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
                          </div>
                       </div>
                  </div>
              }

              <h5 class="section-title">Datos Laborales</h5>
              <div class="columns is-multiline">
                  <div class="column is-6 form-container">
                       <span class="label">Régimen de la Seguridad Social</span>
                       <input class="search-input" type="text" pInputText formControlName="socialSecurityRegime" />
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Encuadramiento</span>
                      <p-dropdown
                        [options]="[
                          { label: 'Régimen General', value: 'general' },
                          { label: 'Régimen Especial Autónomos', value: 'autonomos' }
                        ]"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Seleccionar encuadramiento"
                        formControlName="classification"
                        appendTo="body"
                      >
                      </p-dropdown>
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Autónomos a Cargo de</span>
                      <p-dropdown
                        [options]="[
                          { label: 'Empresa', value: 'empresa' },
                          { label: 'Persona', value: 'persona' }
                        ]"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Seleccionar"
                        formControlName="selfEmployedChargedTo"
                        appendTo="body"
                      >
                      </p-dropdown>
                  </div>
                  @if (store.memberModalForm.get('selfEmployedChargedTo')?.value === 'persona') {
                      <div class="column is-6 form-container">
                        <span class="label">Persona</span>
                        <input
                          class="search-input"
                          type="text"
                          pInputText
                          formControlName="selfEmployedChargedName"
                          placeholder="Nombre persona"
                        />
                      </div>
                  }
                  <div class="column is-6 form-container">
                      <span class="label">IBAN (en Seguridad Social)</span>
                      <input class="search-input" type="text" pInputText formControlName="iban" />
                  </div>
                  <div class="column is-6 form-container">
                       <span class="label">Rendimiento Neto Mensual</span>
                       <p-inputNumber [useGrouping]="true" locale="es-ES" class="search-input" formControlName="monthlyNetIncome"></p-inputNumber>
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Mutua ACC: Trabajo/EP</span>
                      <input class="search-input" type="text" pInputText formControlName="mutualAccidents" />
                  </div>
                  <div class="column is-6 form-container">
                      <span class="label">Mutua CC / IT</span>
                      <input class="search-input" type="text" pInputText formControlName="mutualCommonContingencies" />
                  </div>
              </div>

              <h5 class="section-title">Firmas</h5>
              <div class="columns is-multiline">
                   <div class="column is-4">
                      <label class="checkbox">
                          <p-checkbox formControlName="signsCCAA" [binary]="true"></p-checkbox>
                          <span class="checkbox-label">Firma las CCAA</span>
                      </label>
                  </div>
                  <div class="column is-4">
                      <label class="checkbox">
                          <p-checkbox formControlName="certifiesCCAA" [binary]="true"></p-checkbox>
                          <span class="checkbox-label">Certifica las CCAA</span>
                      </label>
                  </div>
                  <div class="column is-4">
                      <label class="checkbox">
                          <p-checkbox formControlName="signsIS" [binary]="true"></p-checkbox>
                          <span class="checkbox-label">Firma el IS</span>
                      </label>
                  </div>
                  <div class="column is-4">
                      <label class="checkbox">
                          <p-checkbox formControlName="certifiesIS" [binary]="true"></p-checkbox>
                          <span class="checkbox-label">Certifica el IS</span>
                      </label>
                  </div>
                  <div class="column is-4">
                      <label class="checkbox">
                          <p-checkbox formControlName="signsLaborContracts" [binary]="true"></p-checkbox>
                          <span class="checkbox-label">Firma contratos laborales</span>
                      </label>
                  </div>
                  <div class="column is-4">
                      <label class="checkbox">
                          <p-checkbox formControlName="signsLaborDocuments" [binary]="true"></p-checkbox>
                          <span class="checkbox-label">Firma documentos laborales</span>
                      </label>
                  </div>
              </div>

              <div class="column is-12 form-container" style="margin-top: 0.5rem;">
                <span class="label">Observaciones</span>
                <textarea
                  class="search-input observations-field"
                  pInputTextarea
                  [autoResize]="true"
                  formControlName="observations"
                  rows="3"
                ></textarea>
              </div>

          </section>
          <footer class="modal-card-foot buttons-container">
               <button
                class="button cancel-button"
                type="button"
                (click)="store.closeMemberModal()"
              >
                Cancelar
              </button>
              <button class="button save-button" type="submit">Guardar</button>
          </footer>
      </form>
  </div>
</div>
